import { Login } from './components/Login';
import { VNCViewer } from './components/VNCViewer';
import { useStore } from './hooks/useStore';
import { api } from './services/api';
import './App.css';

function App() {
  const { user, logout } = useStore();

  const handleLogout = async () => {
    try {
      await api.logout();
    } catch (err) {
      console.error('[App] Logout failed:', err);
    } finally {
      logout();
    }
  };

  // Not authenticated
  if (!user) {
    return <Login />;
  }

  // Authenticated — VNCViewer handles session lifecycle
  return <VNCViewer user={user} onLogout={handleLogout} />;
}

export default App;
